import { createContext, useContext, useState, useEffect } from "react";
import { Preferences } from '@capacitor/preferences';
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSession = async () => {
      try {
        // 1. Intentamos leer de la memoria nativa (Capacitor)
        const { value: storedUserNative } = await Preferences.get({ key: 'boose_user' });
        const { value: storedTokenNative } = await Preferences.get({ key: 'boose_token' });

        // 2. Intentamos leer de la memoria web (Fallback de seguridad)
        const storedUserWeb = localStorage.getItem('boose_user');
        const storedTokenWeb = localStorage.getItem('boose_token');

        // 3. Elegimos la que haya sobrevivido
        const finalUser = storedUserNative || storedUserWeb;
        const finalToken = storedTokenNative || storedTokenWeb;

        if (finalUser && finalToken) {
          setUser(JSON.parse(finalUser));
          setToken(finalToken);
          axios.defaults.headers.common["Authorization"] = `Bearer ${finalToken}`;
        }
      } catch (error) {
        console.error("Error leyendo la memoria:", error);
      } finally {
        setLoading(false);
      }
    };

    loadSession();
  }, []);

  const login = async (userData, userToken) => {
    const userString = JSON.stringify(userData);
    
    // 💾 Guardamos en AMBAS memorias (Doble escudo)
    await Preferences.set({ key: 'boose_user', value: userString });
    await Preferences.set({ key: 'boose_token', value: userToken });
    
    localStorage.setItem('boose_user', userString);
    localStorage.setItem('boose_token', userToken);
    
    setUser(userData);
    setToken(userToken);
    axios.defaults.headers.common["Authorization"] = `Bearer ${userToken}`;
  };

  const logout = async () => {
    // 🧹 Borramos ambas memorias al salir
    await Preferences.remove({ key: 'boose_user' });
    await Preferences.remove({ key: 'boose_token' });
    
    localStorage.removeItem('boose_user');
    localStorage.removeItem('boose_token');
    
    setUser(null);
    setToken(null);
    delete axios.defaults.headers.common["Authorization"];
  };

  // Muestra una pantalla negra mientras el celular busca las llaves. 
  // Esto evita que el sistema te patee a la pantalla de Login por error.
  if (loading) {
    return <div className="min-h-screen bg-[#09090b]"></div>;
  }

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);